var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.864,
    height: 74.373,
    viewBox: "0 0 52.864 74.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Factuur",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M118.739,74.373H77.624a6.124,6.124,0,0,1-5.874-6.2V6.2A6.124,6.124,0,0,1,77.624,0H108.46a1.441,1.441,0,0,1,1.04.452l14.684,15.494a1.606,1.606,0,0,1,.429,1.1V68.175a6.124,6.124,0,0,1-5.874,6.2M77.624,3.1a3.142,3.142,0,0,0-2.937,3.1V68.175a3.142,3.142,0,0,0,2.937,3.1h41.115a3.142,3.142,0,0,0,2.937-3.1V17.685L107.852,3.1Z",
    transform: "translate(-71.751)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M104.594,22.739H91.33a7.682,7.682,0,0,1-7.58-7.58V1.895a1.895,1.895,0,0,1,3.79,0V15.159a3.941,3.941,0,0,0,3.79,3.79h13.264a1.895,1.895,0,1,1,0,3.79",
    transform: "translate(-53.626)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M103.619,17.79H76.005c-.693,0-1.255-.849-1.255-1.895S75.312,14,76.005,14h27.613c.693,0,1.255.849,1.255,1.895s-.562,1.895-1.255,1.895",
    transform: "translate(-63.381 28.963)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M103.619,14.79H76.005c-.693,0-1.255-.849-1.255-1.895S75.312,11,76.005,11h27.613c.693,0,1.255.849,1.255,1.895s-.562,1.895-1.255,1.895",
    transform: "translate(-63.381 22.759)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M103.619,20.79H76.005c-.693,0-1.255-.849-1.255-1.895S75.312,17,76.005,17h27.613c.693,0,1.255.849,1.255,1.895s-.562,1.895-1.255,1.895",
    transform: "translate(-63.381 35.17)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M99.384,23.79H76.645a1.895,1.895,0,1,1,0-3.79H99.384a1.895,1.895,0,0,1,0,3.79",
    transform: "translate(-67.569 39.213)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M104.384,11.79H81.645a1.895,1.895,0,1,1,0-3.79h22.739a1.895,1.895,0,0,1,0,3.79",
    transform: "translate(-60.601 16.553)",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.8aa0b5f3342e1dda66eae61115059eec.svg";
export { ForwardRef as ReactComponent };